/**
 * External Dependencies
 */
import 'jquery';

$(document).ready(() => {

  // Drop Down menu innerHeight
  var doc_H = $(window).height();
  var head_exclude = $('.header-top-container').outerHeight();
  $('.dropdown-menu').css('height', doc_H - head_exclude);

  // main-menu toggle
  $('.main-menu ul li').click(function () {
    $(this).parents('.center-content').siblings('.dropdown-menu').fadeIn(100);
    $(this).parents('body').addClass('no-scroll');
  });
  $('.main-menu ul li.services-list').click(function () {
    $(this).parents('.center-content').siblings('.dropdown-menu').find('.services-menu').addClass('current-menu-item');
    $(this).parents('.center-content').siblings('.dropdown-menu').find('.services-menu-area').fadeIn(100);
  });
  $('.main-menu ul li.materiels-list').click(function () {
    $(this).parents('.center-content').siblings('.dropdown-menu').find('.materiels-menu').addClass('current-menu-item');
    $(this).parents('.center-content').siblings('.dropdown-menu').find('.materiels-menu-area').fadeIn(100);
  });

  $('.dropdown-main-menu ul li.services-menu').click(function () {
    $(this).addClass('current-menu-item');
    $(this).parents('.dropdown-header').siblings('.dropdown-menu-parents').find('.services-menu-area').fadeIn(100);
    $(this).parents('.dropdown-header').siblings('.dropdown-menu-parents').find('.materiels-menu-area').fadeOut(100);
    $('.dropdown-main-menu ul li.materiels-menu').removeClass('current-menu-item');
  });
  $('.dropdown-main-menu ul li.materiels-menu').click(function () {
    $(this).addClass('current-menu-item');
    $(this).parents('.dropdown-header').siblings('.dropdown-menu-parents').find('.materiels-menu-area').fadeIn(100);
    $(this).parents('.dropdown-header').siblings('.dropdown-menu-parents').find('.services-menu-area').fadeOut(100);
    $('.dropdown-main-menu ul li.services-menu').removeClass('current-menu-item');
  });
  $('.dropdown-close img').click(function () {
    $(this).parents('.dropdown-menu').fadeOut(100);
    $(this).parents('.dropdown-close').siblings('.dropdown-main-menu').find('ul li').removeClass('current-menu-item');
    $(this).parents('.dropdown-header').siblings('.dropdown-menu-parents').find('.dropdown-menu-area').fadeOut(100);
    $(this).parents('body').removeClass('no-scroll');
  });

  $('.main-menu ul li a').click(function (event) {
    event.preventDefault();
  });
  $('.dropdown-main-menu ul li a').click(function (event) {
    event.preventDefault();
  });

  // end main-menu toggle

  // mm-menu
  $(".desk-menu ul li a").click(function (event) {
    event.preventDefault();
  });

  $('.desk-menu ul li').on({
    mouseenter: function () {
      $(this).parents('.desk-menu').addClass('desk-menu-hov');
      $(this).parents('.desk-menu').siblings('.main-menu').addClass('main-menu-hov');
    },
    mouseleave: function () {
      $(this).parents('.desk-menu').removeClass('desk-menu-hov');
      $(this).parents('.desk-menu').siblings('.main-menu').removeClass('main-menu-hov');
    }
  });

  $('.main-menu').on({
    mouseenter: function () {
      $(this).addClass('main-menu-hov');
      $(this).siblings('.desk-menu').addClass('desk-menu-hov');
    },
    mouseleave: function () {
      $(this).removeClass('main-menu-hov');
      $(this).siblings('.desk-menu').removeClass('desk-menu-hov');
    }
  });

  // search js
  $(".search-icon").click(function (e) {
    e.preventDefault();
    $(this).parents('.banner-container ').children(".search-container").toggleClass("search-active");
  });

  // owl carousel js
  if ($('.product-slider .owl-carousel').length > 0) {
    $('.product-slider .owl-carousel').owlCarousel({
      loop: false,
      nav: true,
      pagination: true,
      autoplay: true,
      slideBy: 1,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          margin: 10,
          stagePadding: 40,
        },
        480: {
          items: 2,
          margin: 10,
          stagePadding: 40,
        },
        640: {
          items: 2,
          margin: 10
        },
        840: {
          items: 3,
          margin: 20
        },
        1200: {
          items: 3,
          margin: 40
        }
      }
    });
  }

  // owl carousel js
  if ($('.our-product-slider .owl-carousel').length > 0) {
    $('.our-product-slider .owl-carousel').owlCarousel({
      loop: false,
      nav: true,
      pagination: true,
      autoplay: true,
      slideBy: 1,
      dots: true,
      dotsEach: false,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          margin: 10,
          stagePadding: 30
        },
        480: {
          items: 1,
          margin: 10,
          stagePadding: 30
        },
        640: {
          items: 2,
          margin: 10,
          stagePadding: 30
        },
        767: {
          items: 2,
          margin: 10,
          stagePadding: 50
        },
        840: {
          items: 2,
          margin: 20,
          stagePadding: 75
        },
        1200: {
          items: 2,
          margin: 23,
          stagePadding: 85
        }
      }
    });
  }

  // service-slider js
  if ($('.service-slider .owl-carousel').length > 0) {
    $('.service-slider .owl-carousel').owlCarousel({
      loop: false,
      nav: true,
      pagination: true,
      autoplay: true,
      dots: true,
      dotsEach: false,
      slideBy: 1,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1
        },
        480: {
          items: 1
        },
        640: {
          items: 2,
          margin: 15
        },
        840: {
          items: 4,
          margin: 20
        },
        1100: {
          items: 5,
          margin: 30
        },
        1200: {
          items: 5,
          margin: 37
        }
      }
    });
  }


  // menu-slider carousel js
  if ($('.menu-slider2 .menu-slider .owl-carousel').length > 0) {
    $('.menu-slider2 .menu-slider .owl-carousel').owlCarousel({
      loop: false,
      nav: true,
      items: 3,
      autoWidth:true,
      pagination: true,
      autoplay: false,
      slideBy: 1
    });
  }

  // menu-slider carousel js
  if ($('.menu-slider .owl-carousel').length > 0) {
    $('.menu-slider .owl-carousel').owlCarousel({
      loop: false,
      nav: true,
      items: 4,
      pagination: true,
      autoplay: false,
      autoWidth:true,
      slideBy: 1
    });
  }

  // product page featured btn
  $('.features-btn span').click(function () {
    if ($(this).hasClass('open')) {
      $(this).text('Voir plus de caractéristiques');
      $(this).removeClass('open');
      $('#tab2 .tab-list-area').removeClass('open');
    } else {
      $(this).text('Voir moins de caractéristiques');
      $(this).addClass('open');
      $('#tab2 .tab-list-area').addClass('open');
    }
  });

  // footer toggle
  $('.footer-col:first-child').children('.open_list').addClass('open_list_show');


  // dropkick js
  if ($('.filter-select').length > 0) {
    $(".filter-select").dropkick({
      mobile: true
    });
  }

  // product-sheet-slider slider
  if ($('.product-sheet-slider .owl-carousel').length > 0) {
    var owl1;
    owl1 = $('.product-sheet-slider .owl-carousel').owlCarousel({
      items: 1,
      loop: true,
      dots: true,
      autoplay: false,
      mouseDrag: true,
      autoplaySpeed: 600,
      autoplayTimeout: 15000,
    });

    // slider trigger next/prev when click service-item
    $('.slide-control').on('click', '.item', function (e) {
      owl1.trigger('to.owl.carousel', [$(this).index(), 300]);
    });

    owl1.on('changed.owl.carousel', function (event) {
    });
  }

  // Tab Slider
  $(".tab_content").hide();
  $(".tab-container .tab-item:first").addClass("active").show();
  $(".tab_content:first").show();
  $(".tab-container .tab-item").click(function () {
    $(".tab-container .tab-item").removeClass("active");
    $(this).addClass("active");
    $(".tab_content").hide();
    var activeTab = $(this).find("a").attr("href");
    $(activeTab).fadeIn();
    return false;
  });
  $('.product-sheet-content .see-details a').click(function (e) {
    e.preventDefault();
    let anchor = $(this).attr('href');
    let item = $('#tab_container_area .tab-item');
    item.each(function () {
      $(this).removeClass('active');
    });
    $('#tab_container_area .tab_content_area .tab_content').each(function () {
      $(this).hide();
    });
    $('#tab_container_area .tab-item[aria-controls="' + anchor + '"]').addClass('active');
    $('#tab_container_area .tab_content_area .tab_content[aria-controls="' + anchor + '"]').show();
    $('html').animate({
      scrollTop: item.offset().top - 100
    }, 800);
  });

  // menu slide tab-container
  if ($('.tab-container .owl-carousel').length > 0) {
    var tabOwl = $('.tab-container .owl-carousel');
    tabOwl.owlCarousel({
      loop: false,
      margin: 0,
      responsiveClass: true,
      mouseDrag: false
    });
  }

  function callback(event) {
    var item = event.item.index;
  }

  $(".view-more").click(function (e) {
    e.preventDefault();
    $(this).parent(".peint-view-cont, .product-page-cont").addClass("view-active");
  });

  $(".sidebar-info .filter-close").click(function (e) {
    e.preventDefault();
    $(this).parents('.sidebar').hide();
    $(this).parents('.sidebar').siblings('.product-left').removeClass('sidebar-open');
  });

  $(".filter-btn").click(function (e) {
    $(this).parents('.breadcrumb-container').siblings('.product-container').find('.sidebar').show();
  });

  $(".filter-btn-mobile").click(function (e) {
    $(this).parents('.breadcrumb-container').siblings('.product-container').find('.sidebar').show();
    $('body').addClass('position-fixed');
  });

  // Sidebar for mob
  $(".remove-btn-top a").click(function (e) {
    e.preventDefault();
  });
  $(".remove-btn-top").click(function (e) {
    $(this).parents('.sidebar').hide();
    $('body').removeClass('position-fixed');
  });

  // sticky filter-btn-mobile
  if ($(".filter-btn-mobile").length > 0) {
    var distance = $(".filter-btn-mobile").offset().top;
    $(window).scroll(function () {
      if ($(window).scrollTop() >= distance) {
        $(".filter-btn-mobile").addClass('sticky');
      } else {
        $(".filter-btn-mobile").removeClass('sticky');
      }
    });
  }

  // sticky nav catég mobile
  if ($(".menu-slider2").length > 0) {
    var distance = $(".menu-slider2").offset().top;
    $(window).scroll(function () {
      if ($(window).scrollTop() >= distance) {
        $(".menu-slider2").addClass('sticky');
      } else {
        $(".menu-slider2").removeClass('sticky');
      }
    });
  }

  // Close and make cookie on infoheadband
  if ($(".info-headband").length > 0) {

    $(".info-headband .owl-carousel").owlCarousel({
      items: 1,
      loop: true,
      autoplay: true,
      slideTransition: 'linear',
      autoplayTimeout: 3000,
      autoplayHoverPause: true
    })

    if ($.cookie('info-headband') === 'yes') {
      $('.info-headband').addClass('hide-info');
    }
  }

  // Check if checkbox newsletter is checked
  $(".mailpoet_checkbox_label").click(function () {
    if ($(this).find("input[type='checkbox']").prop("checked") === true) {
      $(".mailpoet_checkbox_label").addClass("checked");
    } else {
      $(".mailpoet_checkbox_label").removeClass("checked");
    }
  });

  // duplicate dropdown facet to btn
  function makeBtnSortOption() {
    let syncedOption = '', sortOption;
    $('.wpgb-facet-11 .wpgb-sort.wpgb-select option').each(function () {
      sortOption = $(this);
      syncedOption += '<span class="icea_product_sort" id="' + sortOption.attr('value') + '" >' + sortOption.text() + '</span>';
    });
    $(syncedOption).appendTo('.filter-button');
  }

  function setSortMobileValue(value) {
    $('.icea_product_sort').each(function () {
      if ($(this).hasClass('btn-blue')) {
        $(this).removeClass('btn-blue');
      }
    });
    $('#' + value).addClass('btn-blue');
  }

  function synchronizeSortFacets(grid) {
    let currentValue;
    $('.icea_product_sort').click(function () {
      currentValue = $(this).attr('id');
      grid.facets.setParams('trier_par', [currentValue]);
      let facetValue = grid.facets.getParams('trier_par');
      setSortMobileValue(facetValue);
      grid.facets.refresh();
    });

    grid.facets.on('change', function (slug, values) {
      // We change the price range
      if (slug === 'trier_par') {
        setSortMobileValue(values[0]);
      }
    });
  }

  makeBtnSortOption();
  let productGrid;

  if ($('.wpgb-facet').length) {
    productGrid = window.WP_Grid_Builder.instances[1];
    synchronizeSortFacets(productGrid);
  }

});

// footer toggle
var winW = $(window).innerWidth();
$(".footer-col h2").click(function () {
  var winW = $(window).innerWidth();
  if (winW <= 640) {
    $(this).toggleClass('open');
    $(this).next('.open_list').slideToggle("slow");
  }
});

var mobMenu = $("#mob-menu").mmenu({
  "navbar": {
    "title": '<div class="header-bottom-right mobile-search">' +
      '<form role="search" method="get" class="woocommerce-product-search search-form" action="/">' +
      '<input type="search" id="" class="search-field" placeholder="Rechercher" value="" name="s" />' +
      '<input type="hidden" name="post_type" value="product" />' +
      '</form>' +
      '</div>',
  },
  "extensions": [
    "fullscreen",
    "fx-menu-slide"
  ]
});

var API = mobMenu.data("mmenu");

var closeIcon = $(".mob-menu-area a");
closeIcon.on("click", function () {
  API.close();
});


/** FileUpload Field **/
const label = $('.gf_file .gfield_label').html();

$('<button class="ginput_fileupload_delete ginput_fileupload_delete_hidden">x</button>').insertAfter('.ginput_container_fileupload');

$('.ginput_fileupload_delete').on('click',function (e){
  e.preventDefault();
  let file = $('.gf_file .ginput_container_fileupload input:file');
  file.val('');
  update_gform_filename(file);
})

$('.gf_file .ginput_container_fileupload input:file').on('change', function (){
  update_gform_filename($(this));
  $('.ginput_fileupload_delete_hidden').removeClass('ginput_fileupload_delete_hidden');
});

function update_gform_filename(target){
  if (target.val() != ''){
    let filename = target[0].files[0].name;
    if(filename.length > 25){
      filename = filename.slice(0,22)+'...';
    }
    $('.gf_file .gfield_label').html('<small>'+filename+'</small>');
  }else {
    $('.gf_file .gfield_label').html(label);
    $('.ginput_fileupload_delete').addClass('ginput_fileupload_delete_hidden');
  }
}



$('<div class="quantity-nav"><div class="quantity-button quantity-up">&lt;</div><div class="quantity-button' +
  ' quantity-down">&gt;</div></div>').insertAfter('.quantity input');
$('.quantity').each(function() {
  let spinner = $(this),
    input = spinner.find('input[type="number"]'),
    btnUp = spinner.find('.quantity-up'),
    btnDown = spinner.find('.quantity-down'),
    min = input.attr('min'),
    max = input.attr('max');

  btnUp.click(function() {
    let oldValue = parseFloat(input.val());
    let newVal = oldValue >= max ? oldValue : oldValue + 1;
    if (!max) {
      newVal = oldValue +1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
  });

  btnDown.click(function() {
    let oldValue = parseFloat(input.val());
    let newVal = oldValue <= min ? oldValue : oldValue - 1;
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
  });
});

$( '.close-cross' ).on( 'click', function() {
  $('.info-headband').remove();
  let data = {'action': 'icea_banner_read'};
  $.ajax({
    type: 'POST',
    data: data,
    url: ajaxurl.admin_url,
  });
});


$(window).scroll(function (event) {
  let scroll = $(window).scrollTop();
  if (scroll > 0){
    $('.home-header .logo').addClass('home-logo-scrolled');
    $('.home-banner-container').addClass('home-banner-container-scrolled');
    $('.banner-container').addClass('banner-container-scrolled');
  } else {
    $('.home-logo-scrolled').removeClass('home-logo-scrolled');
    $('.home-banner-container-scrolled').removeClass('home-banner-container-scrolled');
    $('.banner-container-scrolled').removeClass('banner-container-scrolled');
  }
});

